import { useContext } from 'react';
import { PendingPartnershipsContext } from './charityContext';

export const usePendingPartnerships = () => {
    return useContext(PendingPartnershipsContext);
};
